import Plus from './Plus'

export default Plus
// eslint-disable-next-line import/export
export * from './Plus'
